const vasco = [
  {
    id: 1,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 26/27 - Uniforme 1",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2026",
      "2026 vasco",
      "2026",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/26-27-01/vas0.jpg",
      "/images/brasil/serie-a/vasco/26-27-01/vas1.png",
      "/images/brasil/serie-a/vasco/26-27-01/vas2.jpg",
      "/images/brasil/serie-a/vasco/26-27-01/vas3.jpg",
      "/images/brasil/serie-a/vasco/26-27-01/vas4.jpg",
    ],
  },
  {
    id: 2,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 26/27 - Uniforme 1 (Feminino)",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2026",
      "feminino vasco",
      "vasco feminino",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/26-27-01-f/vas0.jpg",
      "/images/brasil/serie-a/vasco/26-27-01-f/vas1.jpg",
      "/images/brasil/serie-a/vasco/26-27-01-f/vas2.jpg",
      "/images/brasil/serie-a/vasco/26-27-01-f/vas3.jpg",
      "/images/brasil/serie-a/vasco/26-27-01-f/vas4.jpg",
    ],
  },
  {
    id: 3,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 25/26 - Uniforme 1",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2025",
      "2025 vasco",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/25-26-01/vas0.jpg",
      "/images/brasil/serie-a/vasco/25-26-01/vas1.jpg",
      "/images/brasil/serie-a/vasco/25-26-01/vas2.jpg",
      "/images/brasil/serie-a/vasco/25-26-01/vas3.jpg",
      "/images/brasil/serie-a/vasco/25-26-01/vas4.jpg",
    ],
  },
  {
    id: 3,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 25/26 - Uniforme Edição Especial",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2025",
      "2025 vasco",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/vasco/25-26-01-es/vas0.jpg",
      "/images/brasil/serie-a/vasco/25-26-01-es/vas1.jpg",
      "/images/brasil/serie-a/vasco/25-26-01-es/vas2.jpg",
      "/images/brasil/serie-a/vasco/25-26-01-es/vas3.jpg",
      "/images/brasil/serie-a/vasco/25-26-01-es/vas4.jpg",
    ],
  },
  {
    id: 4,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 25/26 - Uniforme de Goleiro (Azul)",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2025",
      "2025 vasco",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/25-26-06-ga/vas0.jpg",
      "/images/brasil/serie-a/vasco/25-26-06-ga/vas1.jpg",
      "/images/brasil/serie-a/vasco/25-26-06-ga/vas2.jpg",
      "/images/brasil/serie-a/vasco/25-26-06-ga/vas3.jpg",
      "/images/brasil/serie-a/vasco/25-26-06-ga/vas4.jpg",
    ],
  },
  {
    id: 5,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 25/26 - Uniforme de Goleiro (Laranja)",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2025",
      "2025 vasco",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/25-26-06-gl/vas0.jpg",
      "/images/brasil/serie-a/vasco/25-26-06-gl/vas1.jpg",
      "/images/brasil/serie-a/vasco/25-26-06-gl/vas2.jpg",
      "/images/brasil/serie-a/vasco/25-26-06-gl/vas3.jpg",
      "/images/brasil/serie-a/vasco/25-26-06-gl/vas4.jpg",
    ],
  },
  {
    id: 6,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 25/26 - Uniforme Edição Especial",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2025",
      "2025 vasco",
      "2025",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/vasco/25-26-09-es/vas0.jpg",
      "/images/brasil/serie-a/vasco/25-26-09-es/vas1.jpg",
      "/images/brasil/serie-a/vasco/25-26-09-es/vas2.jpg",
      "/images/brasil/serie-a/vasco/25-26-09-es/vas3.jpg",
      "/images/brasil/serie-a/vasco/25-26-09-es/vas4.jpg",
    ],
  },
  {
    id: 7,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 25/26 - Jaqueta Preta",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco jaqueta",
      "jaqueta vasco",
      "jaqueta",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/25-26-09-jp/vas0.png",
      "/images/brasil/serie-a/vasco/25-26-09-jp/vas1.png",
      "/images/brasil/serie-a/vasco/25-26-09-jp/vas2.png",
      "/images/brasil/serie-a/vasco/25-26-09-jp/vas3.png",
      "/images/brasil/serie-a/vasco/25-26-09-jp/vas4.png",
    ],
  },
  {
    id: 8,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 25-26 - Uniforme de Goleiro (Azul) (Feminino)",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2025",
      "feminino vasco",
      "vasco feminino",
      "feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/25-26-06-gaf/vas0.jpg",
      "/images/brasil/serie-a/vasco/25-26-06-gaf/vas1.jpg",
      "/images/brasil/serie-a/vasco/25-26-06-gaf/vas2.jpg",
      "/images/brasil/serie-a/vasco/25-26-06-gaf/vas3.jpg",
      "/images/brasil/serie-a/vasco/25-26-06-gaf/vas4.jpg",
    ],
  },
  {
    id: 9,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 24/25 - Uniforme Black",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2024",
      "2024 vasco",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/24-25-00-b/vas0.jpg",
      "/images/brasil/serie-a/vasco/24-25-00-b/vas1.jpg",
      "/images/brasil/serie-a/vasco/24-25-00-b/vas2.jpg",
      "/images/brasil/serie-a/vasco/24-25-00-b/vas3.jpg",
      "/images/brasil/serie-a/vasco/24-25-00-b/vas4.jpg",
    ],
  },
  {
    id: 10,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 24/25 - Uniforme Edição Especial",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2024",
      "2024 vasco",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/vasco/24-25-00-es/vas0.jpg",
      "/images/brasil/serie-a/vasco/24-25-00-es/vas1.jpg",
      "/images/brasil/serie-a/vasco/24-25-00-es/vas2.jpg",
      "/images/brasil/serie-a/vasco/24-25-00-es/vas3.jpg",
      "/images/brasil/serie-a/vasco/24-25-00-es/vas4.jpg",
    ],
  },
  {
    id: 11,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 24/25 - Uniforme Edição Especial (Feminino)",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2024",
      "feminino vasco",
      "vasco feminino",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/24-25-00-es/vas0.jpg",
      "/images/brasil/serie-a/vasco/24-25-00-es/vas1.jpg",
      "/images/brasil/serie-a/vasco/24-25-00-es/vas2.jpg",
      "/images/brasil/serie-a/vasco/24-25-00-es/vas3.jpg",
      "/images/brasil/serie-a/vasco/24-25-00-es/vas4.jpg",
    ],
  },
  {
    id: 12,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 24/25 - Uniforme 1",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2024",
      "2024 vasco",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/24-25-01/vas0.jpg",
      "/images/brasil/serie-a/vasco/24-25-01/vas1.jpg",
      "/images/brasil/serie-a/vasco/24-25-01/vas2.jpg",
      "/images/brasil/serie-a/vasco/24-25-01/vas3.jpg",
      "/images/brasil/serie-a/vasco/24-25-01/vas4.jpg",
    ],
  },
  {
    id: 13,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 24/25 - Uniforme Edição Especial",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2024",
      "2024 vasco",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/vasco/24-25-01-es/vas0.jpg",
      "/images/brasil/serie-a/vasco/24-25-01-es/vas1.jpg",
      "/images/brasil/serie-a/vasco/24-25-01-es/vas2.jpg",
      "/images/brasil/serie-a/vasco/24-25-01-es/vas3.jpg",
      "/images/brasil/serie-a/vasco/24-25-01-es/vas4.jpg",
    ],
  },
  {
    id: 12,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 24/25 - Uniforme 1 Manga Longa",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2024",
      "2024 vasco",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/24-25-01-mc/vas0.jpg",
      "/images/brasil/serie-a/vasco/24-25-01-mc/vas1.jpg",
      "/images/brasil/serie-a/vasco/24-25-01-mc/vas2.jpg",
      "/images/brasil/serie-a/vasco/24-25-01-mc/vas3.jpg",
      "/images/brasil/serie-a/vasco/24-25-01-mc/vas4.jpg",
    ],
  },
  {
    id: 13,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 24/25 - Uniforme 2",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2024",
      "2024 vasco",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/24-25-02/vas0.jpg",
      "/images/brasil/serie-a/vasco/24-25-02/vas1.jpg",
      "/images/brasil/serie-a/vasco/24-25-02/vas2.jpg",
      "/images/brasil/serie-a/vasco/24-25-02/vas3.jpg",
      "/images/brasil/serie-a/vasco/24-25-02/vas4.jpg",
    ],
  },
  {
    id: 14,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 24/25 - Regata 2",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2024",
      "regata vasco",
      "regata vasco",
      "regata",
    ],
    tipo: "masculino",
    categoria: "regata",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/24-25-02-re/vas0.jpg",
      "/images/brasil/serie-a/vasco/24-25-02-re/vas1.jpg",
      "/images/brasil/serie-a/vasco/24-25-02-re/vas2.jpg",
      "/images/brasil/serie-a/vasco/24-25-02-re/vas3.jpg",
    ],
  },
  {
    id: 15,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 24/25 - Uniforme 3",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2024",
      "2024 vasco",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/24-25-03/vas0.jpg",
      "/images/brasil/serie-a/vasco/24-25-03/vas1.jpg",
      "/images/brasil/serie-a/vasco/24-25-03/vas2.jpg",
      "/images/brasil/serie-a/vasco/24-25-03/vas3.jpg",
      "/images/brasil/serie-a/vasco/24-25-03/vas4.jpg",
    ],
  },
  {
    id: 16,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 24/25 - Uniforme de Pré Jogo (Azul)",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2024",
      "2024 vasco",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/24-25-05-pja/vas0.jpg",
      "/images/brasil/serie-a/vasco/24-25-05-pja/vas1.jpg",
      "/images/brasil/serie-a/vasco/24-25-05-pja/vas2.jpg",
      "/images/brasil/serie-a/vasco/24-25-05-pja/vas3.jpg",
      "/images/brasil/serie-a/vasco/24-25-05-pja/vas4.jpg",
    ],
  },
  {
    id: 17,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 24/25 - Uniforme de Pré Jogo (Verde)",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2024",
      "2024 vasco",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/24-25-05-pjv/vas0.jpg",
      "/images/brasil/serie-a/vasco/24-25-05-pjv/vas1.jpg",
      "/images/brasil/serie-a/vasco/24-25-05-pjv/vas2.jpg",
      "/images/brasil/serie-a/vasco/24-25-05-pjv/vas3.jpg",
      "/images/brasil/serie-a/vasco/24-25-05-pjv/vas4.jpg",
    ],
  },
  {
    id: 18,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 24/25 - Uniforme Edição Especial",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2024",
      "2024 vasco",
      "2024",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/vasco/24-25-08-es/vas0.jpg",
      "/images/brasil/serie-a/vasco/24-25-08-es/vas1.jpg",
      "/images/brasil/serie-a/vasco/24-25-08-es/vas2.jpg",
      "/images/brasil/serie-a/vasco/24-25-08-es/vas3.jpg",
      "/images/brasil/serie-a/vasco/24-25-08-es/vas4.jpg",
    ],
  },
  {
    id: 19,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 23/24 - Calção 1",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco calção",
      "calção vasco",
      "calção",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/23-24-00-c/vas0.jpg",
      "/images/brasil/serie-a/vasco/23-24-00-c/vas1.jpg",
      "/images/brasil/serie-a/vasco/23-24-00-c/vas2.jpg",
      "/images/brasil/serie-a/vasco/23-24-00-c/vas3.jpg",
      "/images/brasil/serie-a/vasco/23-24-00-c/vas4.jpg",
    ],
  },
  {
    id: 20,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 23/24 - Uniforme Edição Especial",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2023",
      "2023 vasco",
      "2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/vasco/23-24-00-es/vas0.jpg",
      "/images/brasil/serie-a/vasco/23-24-00-es/vas1.jpg",
      "/images/brasil/serie-a/vasco/23-24-00-es/vas2.jpg",
      "/images/brasil/serie-a/vasco/23-24-00-es/vas3.jpg",
      "/images/brasil/serie-a/vasco/23-24-00-es/vas4.jpg",
    ],
  },
  {
    id: 21,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 23/24 - Uniforme 2",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2023",
      "2023 vasco",
      "2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/23-24-02/vas0.jpg",
      "/images/brasil/serie-a/vasco/23-24-02/vas1.jpg",
      "/images/brasil/serie-a/vasco/23-24-02/vas2.jpg",
      "/images/brasil/serie-a/vasco/23-24-02/vas3.jpg",
      "/images/brasil/serie-a/vasco/23-24-02/vas4.jpg",
    ],
  },
  {
    id: 22,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 23/24 - Uniforme de Treino (Cinza)",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2023",
      "2023 vasco",
      "2023",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/23-24-05-tc/vas0.jpg",
      "/images/brasil/serie-a/vasco/23-24-05-tc/vas1.jpg",
      "/images/brasil/serie-a/vasco/23-24-05-tc/vas2.jpg",
      "/images/brasil/serie-a/vasco/23-24-05-tc/vas3.jpg",
      "/images/brasil/serie-a/vasco/23-24-05-tc/vas4.jpg",
    ],
  },
  {
    id: 22,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 22/23 - Uniforme 1",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2022",
      "2022 vasco",
      "2022",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/22-23-01/vas0.jpg",
      "/images/brasil/serie-a/vasco/22-23-01/vas1.jpg",
      "/images/brasil/serie-a/vasco/22-23-01/vas2.jpg",
      "/images/brasil/serie-a/vasco/22-23-01/vas3.jpg",
      "/images/brasil/serie-a/vasco/22-23-01/vas4.jpg",
    ],
  },
  {
    id: 23,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 22/23 - Uniforme 2",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2022",
      "2022 vasco",
      "2022",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/22-23-02/vas0.jpg",
      "/images/brasil/serie-a/vasco/22-23-02/vas1.jpg",
      "/images/brasil/serie-a/vasco/22-23-02/vas2.jpg",
      "/images/brasil/serie-a/vasco/22-23-02/vas3.jpg",
      "/images/brasil/serie-a/vasco/22-23-02/vas4.jpg",
    ],
  },
  {
    id: 24,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 22/23 - Uniforme 3",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2022",
      "2022 vasco",
      "2022",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/22-23-03/vas0.jpg",
      "/images/brasil/serie-a/vasco/22-23-03/vas1.jpg",
      "/images/brasil/serie-a/vasco/22-23-03/vas2.jpg",
      "/images/brasil/serie-a/vasco/22-23-03/vas3.jpg",
      "/images/brasil/serie-a/vasco/22-23-03/vas4.jpg",
    ],
  },
  {
    id: 25,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 22/23 - Regata 2",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco regata",
      "regata vasco",
      "regata",
    ],
    tipo: "masculino",
    categoria: "regata",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/22-23-02-re/vas0.jpg",
      "/images/brasil/serie-a/vasco/22-23-02-re/vas1.jpg",
      "/images/brasil/serie-a/vasco/22-23-02-re/vas2.jpg",
      "/images/brasil/serie-a/vasco/22-23-02-re/vas3.jpg",
      "/images/brasil/serie-a/vasco/22-23-02-re/vas4.jpg",
    ],
  },
  {
    id: 26,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 21/22 - Uniforme 1 Edição Especial",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2021",
      "2021 vasco",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/vasco/21-22-01-es/vas0.jpg",
      "/images/brasil/serie-a/vasco/21-22-01-es/vas1.jpg",
      "/images/brasil/serie-a/vasco/21-22-01-es/vas2.jpg",
      "/images/brasil/serie-a/vasco/21-22-01-es/vas3.jpg",
      "/images/brasil/serie-a/vasco/21-22-01-es/vas4.jpg",
    ],
  },
  {
    id: 27,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 21/22 - Uniforme 2 Edição Especial",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2021",
      "2021 vasco",
      "2021",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/vasco/21-22-02-es/vas0.jpg",
      "/images/brasil/serie-a/vasco/21-22-02-es/vas1.jpg",
      "/images/brasil/serie-a/vasco/21-22-02-es/vas2.jpg",
      "/images/brasil/serie-a/vasco/21-22-02-es/vas3.jpg",
      "/images/brasil/serie-a/vasco/21-22-02-es/vas4.jpg",
    ],
  },
  {
    id: 28,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 09/10 - Uniforme 1 Retro",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2009",
      "retro vasco",
      "vasco retro",
      "retro",
      "2009",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/vasco/09-10-01-rt/vas0.jpg",
      "/images/brasil/serie-a/vasco/09-10-01-rt/vas1.jpg",
      "/images/brasil/serie-a/vasco/09-10-01-rt/vas2.jpg",
      "/images/brasil/serie-a/vasco/09-10-01-rt/vas3.jpg",
      "/images/brasil/serie-a/vasco/09-10-01-rt/vas4.jpg",
    ],
  },
  {
    id: 29,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 09/10 - Uniforme 2 Retro",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2009",
      "retro vasco",
      "vasco retro",
      "retro",
      "2009",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/vasco/09-10-02-rt/vas0.jpg",
      "/images/brasil/serie-a/vasco/09-10-02-rt/vas1.jpg",
      "/images/brasil/serie-a/vasco/09-10-02-rt/vas2.jpg",
      "/images/brasil/serie-a/vasco/09-10-02-rt/vas3.jpg",
      "/images/brasil/serie-a/vasco/09-10-02-rt/vas4.jpg",
    ],
  },
  {
    id: 30,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 01/02 - Uniforme 2 Retro",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2001",
      "retro vasco",
      "vasco retro",
      "retro",
      "2001",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/vasco/01-02-02-rt/vas0.jpg",
      "/images/brasil/serie-a/vasco/01-02-02-rt/vas1.jpg",
      "/images/brasil/serie-a/vasco/01-02-02-rt/vas2.jpg",
      "/images/brasil/serie-a/vasco/01-02-02-rt/vas3.jpg",
      "/images/brasil/serie-a/vasco/01-02-02-rt/vas4.jpg",
    ],
  },
  {
    id: 31,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 00/01 - Uniforme 2 Retro",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2000",
      "retro vasco",
      "vasco retro",
      "retro",
      "2000",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/vasco/00-01-00-rt/vas0.jpg",
      "/images/brasil/serie-a/vasco/00-01-00-rt/vas1.jpg",
      "/images/brasil/serie-a/vasco/00-01-00-rt/vas2.jpg",
      "/images/brasil/serie-a/vasco/00-01-00-rt/vas3.jpg",
      "/images/brasil/serie-a/vasco/00-01-00-rt/vas4.jpg",
    ],
  },
  {
    id: 32,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 99/00 - Uniforme 1 Retro Regata",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 2000",
      "retro vasco",
      "vasco retro",
      "retro",
      "2000",
      "regata vasco",
      "vasco regata",
      "regata",
    ],
    tipo: "masculino",
    categoria: "regata",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/vasco/99-00-01-re/vas0.jpg",
      "/images/brasil/serie-a/vasco/99-00-01-re/vas1.jpg",
      "/images/brasil/serie-a/vasco/99-00-01-re/vas2.jpg",
      "/images/brasil/serie-a/vasco/99-00-01-re/vas3.jpg",
      "/images/brasil/serie-a/vasco/99-00-01-re/vas4.jpg",
    ],
  },
  {
    id: 33,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 96/97 - Uniforme 1 Retro",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 1996",
      "retro vasco",
      "vasco retro",
      "retro",
      "1996",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/vasco/96-97-01-rt/vas0.jpg",
      "/images/brasil/serie-a/vasco/96-97-01-rt/vas1.jpg",
      "/images/brasil/serie-a/vasco/96-97-01-rt/vas2.jpg",
      "/images/brasil/serie-a/vasco/96-97-01-rt/vas3.jpg",
      "/images/brasil/serie-a/vasco/96-97-01-rt/vas4.jpg",
    ],
  },
  {
    id: 34,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 87/88 - Uniforme 2 Retro",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 1988",
      "retro vasco",
      "vasco retro",
      "retro",
      "1988",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/vasco/87-88-01-rt/vas0.jpg",
      "/images/brasil/serie-a/vasco/87-88-01-rt/vas1.jpg",
      "/images/brasil/serie-a/vasco/87-88-01-rt/vas2.jpg",
      "/images/brasil/serie-a/vasco/87-88-01-rt/vas3.jpg",
      "/images/brasil/serie-a/vasco/87-88-01-rt/vas4.jpg",
    ],
  },
  {
    id: 35,
    pais: "brasil",
    liga: "serie-a",
    time: "vasco",
    nome: "Vasco 87/88 - Uniforme 2 Retro",
    aliases: [
      "vasco",
      "gigante da colina",
      "vascão",
      "vasco 1988",
      "retro vasco",
      "vasco retro",
      "retro",
      "1988",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/vasco/87-88-02-rt/vas0.jpg",
      "/images/brasil/serie-a/vasco/87-88-02-rt/vas1.jpg",
      "/images/brasil/serie-a/vasco/87-88-02-rt/vas2.jpg",
      "/images/brasil/serie-a/vasco/87-88-02-rt/vas3.jpg",
      "/images/brasil/serie-a/vasco/87-88-02-rt/vas4.jpg",
    ],
  },
];

export default vasco;
